<template>
  <div class="listing-product">
    <NuxtLink
      class="listing-product__link"
      :to="
        localePath({
          name: 'product-slug',
          params: {
            slug: props.product.slug,
          },
        })
      "
    >
      <div class="listing-product__content">
        <div class="image-container">
          <img
            v-if="props.product.Immagine_Listing && props.product.title"
            :src="props.product.Immagine_Listing"
            width="500"
            height="600"
            :alt="props.product.title"
          />
        </div>
        <div class="text-container">
          <p
            v-if="props.product.title"
            v-html="props.product.title"
            class="title-base3"
          />
          <div
            v-if="props.product.Sezione_BIO.length > 0"
            class="text-small bio"
          >
            <p
              v-for="(item, index) in props.product.Sezione_BIO"
              :key="index"
              v-html="$t('product.' + item)"
            />
          </div>
          <div
            v-if="localizedDescrizioneProdotto"
            v-html="shortDescrizioneProdotto"
            class="text-base product-description"
          />
          <div class="text-base default-icon-btn show-for-large">
            <span class="is-medium-bold">{{ $t('common.prodotto') }}</span>
            <ArrowIcon alt="Arrow icon" class="icon-arrow" />
          </div>
        </div>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup>
import ArrowIcon from '@/assets/img/ico/arrow-mobile.svg'

const props = defineProps({
  product: Object,
})

const { locale } = useI18n()
const getLocalizedField = (field) => {
  switch (locale.value) {
    case 'en':
      return props.product[`${field}_EN`]
    case 'es':
      return props.product[`${field}_ES`]
    case 'fr':
      return props.product[`${field}_FR`]
    default:
      return props.product[`${field}_IT`]
  }
}

const localizedDescrizioneProdotto = computed(() =>
  getLocalizedField('Descrizione_Prodotto'),
)

const shortDescrizioneProdotto = computed(() => {
  const descrizione = localizedDescrizioneProdotto.value || ''
  const parts = descrizione.split('.')
  if (parts.length > 2) {
    return parts.slice(0, 2).join('.') + '.'
  } else if (parts.length > 1) {
    return parts.slice(0, 1).join('.') + '.'
  } else {
    return descrizione
  }
})
</script>

<script>
export default {
  name: 'ListingProduct',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
